import { getTheme, ITheme } from '@fluentui/react/lib/Styling';
import { StylesConfig } from 'react-select/src/styles';
import { CSSProperties } from 'react';
import { SelectOption } from './types';

const theme: ITheme = getTheme();
const { palette } = theme;

export const customStyles = (fixedWidth?: number): StylesConfig<SelectOption, false> => ({
    container: (base: CSSProperties) => ({
        ...base,
        color: palette.neutralSecondary,
        /*
        textTransform: 'none',
        letterSpacing: '0',
        fontSize: '1.4rem',
        fontWeight: 'normal',
        fontFamily: 'Lato, sans-serif',
        lineHeight: '1.4rem',
        color: 'var(--white)',
        border: 'var(--slate)',
         */
    }),
    valueContainer: (base: CSSProperties) => ({
        ...base,
        padding: '2px 8px 1px 8px',
    }),
    indicatorsContainer: (base: CSSProperties) => ({
        ...base,
        padding: '0px 0px 0px 8px',
        height: 29,
    }),
    control: (base: CSSProperties, props) => {
        return {
            ...base,
            borderRadius: 0,
            borderColor: props.isDisabled ? palette.neutralLighter : palette.neutralSecondary,
            minHeight: 29,
            /*
            backgroundColor: 'var(--slate)',
            borderRadius: '4px',
            borderWidth: '1px',
            borderColor: 'var(--slate)',
            boxShadow: 'none',
            width: '100%',
            outline: 'none',
            transition: 'border-color 100ms',
            '&:hover': {
                outline: 'none',
                borderColor: state.isFocused ? 'var(--sky-blue)' : 'var(--slate)',
            },
            '&:focus': {
                borderColor: 'var(--sky-blue)',
            },
             */
        };
    },
    indicatorSeparator: (base, props) => ({
        ...base,
        // backgroundColor: palette.neutralSecondary,
        backgroundColor: props.isDisabled ? palette.neutralQuaternary : palette.neutralSecondary,
        /*
        marginTop: '4px',
        marginBottom: '4px',
        backgroundColor: 'var(--slate-light)',
         */
    }),
    input: (base) => ({
        ...base,
        // color: 'var(--white)',
        color: palette.neutralSecondary,
    }),
    singleValue: (base) => ({
        ...base,
        // color: 'var(--white)',
    }),
    dropdownIndicator: (base, props) => ({
        ...base,
        color: props.isDisabled ? palette.neutralQuaternary : palette.neutralSecondary,
        padding: '2px 4px 1px 4px',
        // color: state.isFocused ? 'var(--white)' : 'var(--grey)',
        // transition: 'color 100ms',
        // '&:hover': {
        //     color: state.isFocused ? 'var(--white)' : 'var(--grey)',
        // },
    }),
    placeholder: (base) => ({
        ...base,
        color: palette.neutralSecondary,
        // color: 'var(--grey-light)',
    }),
    menu: (base) => ({
        ...base,
        zIndex: 9999,
        /*
        borderRadius: '4px',
        border: '2px solid var(--slate-light)',
        backgroundColor: 'var(--slate)',
        boxShadow: 'none',
        padding: '2px',
        margin: '0.6rem 0',
         */
    }),
    menuList: (base) => ({
        ...base,
        position: fixedWidth ? 'fixed' : 'relative',
        width: fixedWidth || undefined,
        backgroundColor: palette.white,
        // padding: 0,
    }),
    option: (base) => ({
        ...base,
        color: palette.neutralSecondary,
        /*
        fontSize: '1.4rem',
        padding: '1.2rem',
        borderRadius: '2px',
        cursor: 'pointer',
        backgroundColor: state.isFocused ? 'var(--slate-light)' : 'var(--slate)',
        borderColor: state.isFocused ? 'var(--slate-light)' : 'transparent',
        color: state.isFocused ? 'white' : 'var(--grey-light)',
        ':active': {
            filter: 'brightness(0.8)',
        },
         */
    }),
    noOptionsMessage: (base) => ({
        ...base,
        color: palette.neutralSecondary,
        // color: 'var(--slate-light)',
    }),
    group: (base) => ({
        ...base,
        color: palette.neutralSecondary,
        // padding: 0,
        // color: 'var(--white)',
    }),
    groupHeading: (base) => ({
        ...base,
        color: palette.neutralSecondary,
        /*
        fontSize: '1.4rem',
        fontWeight: 'bold',
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
        lineHeight: '1em',
        padding: '0.6rem 1.2rem',
        color: 'var(--white)',
        margin: 0,
         */
    }),
    multiValue: (base) => ({
        ...base,
        // backgroundColor: 'var(--grey)',
    }),
    multiValueLabel: (base) => ({
        ...base,
        // color: 'var(--white)',
    }),

    /*
    tag: (base) => ({
        ...base,
        color: 'var(--white)',
        backgroundColor: 'transparent',
    }),
     */
});
